export class UserVerification {
    userId: string;
    merchant: string;
}
export class UpdateUserVerification extends UserVerification {
    isVerified: boolean;
}

export class PaymentVerification {
    userId: string;
    merchant: string;
    paymentSystem: string;
    payer: string;
    isVerified: boolean;
}
export interface PsVerificationStatus {
    verified?: PaymentSystemVerificationDetail[];
    notVerified?: PaymentSystemVerificationDetail[];
}

export interface PaymentSystemVerificationDetail {
    name: string;
    payer: string;
}

export interface PaymentSystemVerificationTable
    extends PaymentSystemVerificationDetail {
    verified: boolean;
}

export enum IdentityVerificationStatus {
    VERIFIED = 'VERIFIED',
    NOT_FOUND = 'NOT FOUND',
    NOT_VERIFIED = 'NOT VERIFIED',
}
